<template>
	<div class="item_sidebar">
		<div class="wrapper_title mb_0">
			<div class="title" v-if="title">{{title}}</div>

			<div class="grp">
				<a @click="updatedData('stretch')" v-tippy="{theme:'small-black'}" content="Stretch"
				   :class="['small-btn', {'active': currentAlignment === 'stretch'}, {'disabled':!canStretch}]">
					<svg width="15" height="13" viewBox="0 0 15 13" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path fill-rule="evenodd" clip-rule="evenodd" d="M12.5 4.9107V7.5893C12.5 8.2536 11.9208 8.75 11.25 8.75H3.125C2.45419 8.75 1.875 8.2536 1.875 7.5893V4.9107C1.875 4.2464 2.45419 3.75 3.125 3.75H11.25C11.9208 3.75 12.5 4.2464 12.5 4.9107ZM3.125 5V7.5H11.25V5H3.125ZM0 0H1.25V12.5H0V0Z" fill="#97AACD"/>
						<rect x="13.2002" width="1.25" height="12.5" fill="#97AACD"/>
					</svg>
				</a>
				<a @click="updatedData('flex-start')" v-tippy="{theme:'small-black'}" content="Align to left"
				   :class="['small-btn', {'active': currentAlignment === 'flex-start'}]">
					<svg viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path fill-rule="evenodd" clip-rule="evenodd" d="M12.75 5.16071V7.83929C12.75 8.50355 12.1708 9 11.5 9H3.375C2.70419 9 2.125 8.50355 2.125 7.83929V5.16071C2.125 4.49645 2.70419 4 3.375 4H11.5C12.1708 4 12.75 4.49645 12.75 5.16071ZM3.375 5.25V7.75H11.5V5.25H3.375ZM0.25 0.25H1.5V12.75H0.25V0.25Z" fill="#97AACD"/>
					</svg>
				</a>
				<a @click="updatedData('center')" v-tippy="{theme:'small-black'}" content="Align to center"
				   :class="['small-btn', {'active': !currentAlignment || currentAlignment === 'center'},
				    {'disabled':isFaq}]">
					<svg viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path fill-rule="evenodd" clip-rule="evenodd" d="M6.58936 9H2.21436C1.54355 9 0.964355 8.50355 0.964355 7.83929V5.16071C0.964355 4.49645 1.54355 4 2.21436 4H6.58936V0.25H7.83936V4H12.2144C12.8852 4 13.4644 4.49645 13.4644 5.16071V7.83929C13.4644 8.50355 12.8852 9 12.2144 9H7.83936V12.75H6.58936V9ZM2.21436 5.25V7.75H12.2144V5.25H2.21436Z" fill="#97AACD"/>
					</svg>
				</a>
				<a @click="updatedData('flex-end')" v-tippy="{theme:'small-black'}" content="Align to right"
				   :class="['small-btn', {'active': currentAlignment === 'flex-end'}]">
					<svg viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path fill-rule="evenodd" clip-rule="evenodd" d="M11.3035 5.16071V7.83929C11.3035 8.50355 10.7243 9 10.0535 9H1.92847C1.25766 9 0.678467 8.50355 0.678467 7.83929V5.16071C0.678467 4.49645 1.25766 4 1.92847 4H10.0535C10.7243 4 11.3035 4.49645 11.3035 5.16071ZM1.92847 5.25V7.75H10.0535V5.25H1.92847ZM11.9285 0.25H13.1785V12.75H11.9285V0.25Z" fill="#97AACD"/>
					</svg>
				</a>
			</div>
		</div>
	</div>
</template>

<script>

import {mapGetters} from "vuex";
import {getAlignment} from "@/modules/page-editor/src/utils/props";

export default {
	name: 'alignment',
	props: ['title', 'value', 'content'],
	components: {
	},
	data: function(){
		return {
			align: {mobile:null,desktop:'center',tablet:null},
		}
	},
	computed:{
		...mapGetters(['current_view']),
		currentAlignment() {
			if (this.isFaq) {
				if (!['flex-start','flex-end'].includes(this.align||'')) return 'flex-end';
				return this.align;
			}
			return getAlignment(this.align, this.current_view)
		},
		canStretch() {
			return this.content.type==='button';
		},
		isFaq() {
			return this.content.type==='faq';
		}
	},
	methods: {
		updatedData(val){
			if (this.isFaq) {
				this.align = val; // Faq does not support multi-device.
				this.$emit('updated', this.align);
				return
			}

			let view = this.current_view;
			if (view==="tablets") view="tablet"; // fixes this.

			if (typeof this.align !== 'object')
				this.align = {mobile:null,desktop:'center',tablet:null};
			this.align[view] = val;
			this.$emit('updated', this.align);
		},
	},
	created() {
		if (this.isFaq)
			this.align = this.value || 'flex-end';
		else
			this.align = this.value ? JSON.parse(JSON.stringify(this.value)) : {mobile:null,desktop:'center',tablet:null};
	}
}
</script>

<style lang="scss" scoped>
.grp {
	display: flex;
	flex-direction: row;
	.small-btn {
		height: 32px;
		width: 32px;
		margin: 0 3px;
	}
}
</style>
